import React, { useState } from 'react';
import axios from 'axios';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Container, Typography, TextField, Button, Snackbar, Alert, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import Quill from 'quill';
import MediaUploadField from './MediaUploadField';

const fonts = ['Arial', 'Verdana', 'Century Schoolbook', 'Times New Roman', 'Sans-serif'];
const fontNames = fonts.map(font => font.toLowerCase().replace(/\s/g, '-'));
 
const Font = Quill.import('formats/font');
Font.whitelist = fontNames;
Quill.register(Font, true);

const modules = {
    toolbar: [
        [{ font: fontNames }],
        [{ header: '1' }, { header: '2' }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        ['link', 'image', 'blockquote', 'code-block'],
        ['clean'],
    ],
};

const stripHtml = (value = '') =>
  String(value).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();

const DashboardPodcast = () => {
    const apiUrl = process.env.REACT_APP_API_URL || "/api";

    const [formData, setFormData] = useState({
        username: '',
        password: '',
        titulo: '',
        apresentadores: '',
        producao: '',
        roteiro: '',
        edicao: '',
        fonte: '',
        creditos: '',
        creditosDetalhados: '',
        linkEpisodio: '',
        linkImagem: '',
        descricao: '',
        serie: 'trajetorias-pesquisa',
    });

    const [alertMessage, setAlertMessage] = useState({ type: '', text: '' });
    const [openSnackbar, setOpenSnackbar] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const setFieldValue = (name, value) => {
        setFormData((prev) => ({ ...prev, [name]: value }));
    };
    const handleUploadError = (message) => {
        setAlertMessage({ type: 'error', text: message });
        setOpenSnackbar(true);
    };
    const handleUploadSuccess = (message) => {
        setAlertMessage({ type: 'success', text: message });
        setOpenSnackbar(true);
    };

    
   

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem('token');
        if (!token) {
            setAlertMessage({ type: 'error', text: 'Você precisa estar autenticado para enviar um podcast.' });
            setOpenSnackbar(true);
            return;
        }

        const requiredFields = [
          ['Título', formData.titulo],
          ['Arquivo de áudio', formData.linkEpisodio],
          ['Imagem do episódio', formData.linkImagem],
          ['Apresentadores', formData.apresentadores],
          ['Produção', formData.producao],
          ['Roteiro', formData.roteiro],
          ['Edição', formData.edicao],
          ['Fonte', formData.fonte],
          ['Créditos', formData.creditos],
          ['Descrição', formData.descricao],
        ];
        const missing = requiredFields
          .filter(([, value]) => !stripHtml(value))
          .map(([label]) => label);

        if (missing.length) {
          setAlertMessage({
            type: 'error',
            text: `Preencha os campos obrigatórios: ${missing.join(', ')}.`,
          });
          setOpenSnackbar(true);
          return;
        }

        const producaoArray = formData.producao.split(',').map((nome) => nome.trim());

        try {
            await axios.post(`${apiUrl}/podcasts`, { ...formData, producao: producaoArray }, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setAlertMessage({ type: 'success', text: 'Podcast adicionado com sucesso!' });
            setFormData({
                titulo: '',
                apresentadores: '',
                producao: '',
                roteiro: '',
                edicao: '',
                fonte: '',
                creditos: '',
                creditosDetalhados: '',
                linkEpisodio: '',
                linkImagem: '',
                descricao: '',
                serie: 'trajetorias-pesquisa',
            });
        } catch (error) {
            const backendMessage = error?.response?.data?.error || error?.response?.data?.message;
            setAlertMessage({ type: 'error', text: backendMessage || 'Erro ao adicionar o podcast. Tente novamente.' });
        }
        setOpenSnackbar(true);
    };

    return (
        <Container
        maxWidth="lg"
        style={{
          backgroundColor: "#f9f9f9",
          borderRadius: "12px",
          padding: "32px",
          boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
          marginTop: "32px",
        }}
      >
            <hr style={{ margin: '40px 0', borderTop: '1px solid #ddd' }} />
            <hr style={{ margin: '40px 0', borderTop: '1px solid #ddd' }} />

            <Typography
                variant="h2"
                align="center"
                gutterBottom
                style={{
                    fontFamily: "'Lato', serif",
                    color: "black",
                    borderBottom: "4px solidrgb(8, 8, 7)",
                    paddingBottom: "10px",
                    textTransform: "uppercase",
                    borderBottom: "4px solid #d4af37",
                    animation: "glow 2s infinite alternate",
                    marginTop: "7%"  // Aqui é onde você define o espaço superior
                }}
            >
           Painel de Divulgação Científica

        </Typography>
      
        <form onSubmit={handleSubmit}>
          <Typography variant="h5" align="center" gutterBottom>
                                  Adicionar novo Podcast 
                              </Typography>
          <TextField
            fullWidth
            label="Título"
            name="titulo"
            value={formData.titulo}
            onChange={handleChange}
            required
            margin="normal"
            variant="outlined"
            style={{ marginBottom: "16px" }}
          />
          <FormControl fullWidth margin="normal" style={{ marginBottom: "16px" }}>
            <InputLabel id="serie-podcast-label">Seção do Podcast</InputLabel>
            <Select
              labelId="serie-podcast-label"
              name="serie"
              value={formData.serie}
              label="Seção do Podcast"
              onChange={handleChange}
            >
              <MenuItem value="trajetorias-pesquisa">
                Sessão 1 - História da Península e Trajetórias de Pesquisa: um podcast sobre o mundo ibérico medieval e moderno
              </MenuItem>
              <MenuItem value="calila-dimna">
                Sessão 2 - Podcast - O papel moral das fábulas na Castela do século XIII: as histórias de Calila e Dimna (Comunicar Ciência)
              </MenuItem>
            </Select>
          </FormControl>

          <MediaUploadField
            label="Arquivo de áudio (episódio)"
            name="linkEpisodio"
            value={formData.linkEpisodio}
            onChange={setFieldValue}
            folder="podcast"
            accept="audio/*,.mp3"
            required
            onError={handleUploadError}
            onSuccess={handleUploadSuccess}
          />
          
          <MediaUploadField
            label="Imagem do episódio"
            name="linkImagem"
            value={formData.linkImagem}
            onChange={setFieldValue}
            folder="podcast"
            accept="image/*"
            required
            onError={handleUploadError}
            onSuccess={handleUploadSuccess}
          />
      
          {[
            { label: "Apresentadores", field: "apresentadores" },
            { label: "Produção", field: "producao" },
            { label: "Roteiro", field: "roteiro" },
            { label: "Edição", field: "edicao" },
            { label: "Fonte", field: "fonte" },
            { label: "Créditos", field: "creditos" },
            { label: "Créditos Detalhados", field: "creditosDetalhados" },
            { label: "Descrição", field: "descricao" },
          ].map(({ label, field }) => (
            <div key={field} style={{ marginBottom: "24px" }}>
              <Typography
                variant="h6"
                style={{
                  fontWeight: "bold",
                  color: "#333",
                  marginBottom: "8px",
                }}
              >
                {label}
              </Typography>
              <ReactQuill
                value={formData[field]}
                onChange={(value) =>
                  setFormData({ ...formData, [field]: value })
                }
                modules={modules}
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "8px",
                  border: "1px solid #ddd",
                  padding: "8px",
                }}
              />
            </div>
          ))}
      
          
      
          <Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            size="large"
            style={{
              marginTop: "16px",
              padding: "12px",
              fontWeight: "bold",
              backgroundColor: "#1976d2",
              borderRadius: "8px",
              textTransform: "none",
            }}
          >
            Enviar
          </Button>
        </form>
      
            
             
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={() => setOpenSnackbar(false)}>
                <Alert severity={alertMessage.type}>{alertMessage.text}</Alert>
            </Snackbar>
        </Container>
    );
};

export default DashboardPodcast;
